import { Subscribable, UNKNOWN } from '../Subscribable.js';
class DefaultSubscribable extends Subscribable {
    constructor(upstream, defaultValue) {
        super();
        this.upstream = upstream;
        this.defaultValue = defaultValue;
        this.val = UNKNOWN;
        this.upstreamCallback = val => {
            this.val = val;
            this.changed();
        };
    }
    subscriptionsWillChange(hasSubscriptions) {
        this.upstream[hasSubscriptions ? 'subscribe' : 'unsubscribe'](this.upstreamCallback);
    }
    get() {
        return this.val !== UNKNOWN ? this.val : this.defaultValue;
    }
}
/**
 * Creates a dependent observable that immediately resolves with the given value if the existing one doesn’t yet have a value.
 *
 * @param upstream the observable to use
 * @param defaultValue the value to emit until upstream emits a value
 * @returns an observable that is guaranteed to always immediately emit whenever subscribed to.
 */
export function withDefault(upstream, defaultValue) {
    return new DefaultSubscribable(upstream, defaultValue);
}
